// Alle prijsindicaties op één plek. Pas hier de bedragen aan; de site gebruikt ze overal.

export const PRICE_NOTE =
  "Alle bedragen zijn indicaties inclusief btw voor particulieren (zakelijk exclusief btw). De exacte prijs voor uw situatie berekent u in 60 seconden met onze calculator.";

export const housePrices = [
  { type: "Appartement / benedenwoning", from: "€25", note: "Buitenzijde, begane grond of galerij" },
  { type: "Rijtjeswoning", from: "€35", note: "Voor- en achterzijde, 2 verdiepingen" },
  { type: "Twee-onder-een-kapwoning", from: "€45", note: "Inclusief zijgevel" },
  { type: "Vrijstaande woning", from: "€55", note: "Afhankelijk van aantal ramen en hoogte" },
  { type: "Villa / veel glas / serre", from: "Op maat", note: "Wij komen graag vrijblijvend kijken" },
];

export const servicePrices = {
  glasbewassing: { from: "€35", unit: "per beurt", note: "Buitenzijde rijtjeswoning; binnenzijde op aanvraag" },
  "zonnepanelen-reinigen": { from: "€4", unit: "per paneel", note: "Minimaal €75 per bezoek" },
  "kozijnen-reinigen": { from: "€35", unit: "per beurt", note: "Voordeliger in combinatie met glasbewassing" },
  "houtwerk-reinigen": { from: "€45", unit: "per beurt", note: "Afhankelijk van oppervlak en vervuiling" },
  "dakgoten-leeghalen": { from: "€65", unit: "per woning", note: "Inclusief afvoer van het vuil" },
  "dak-reinigen": { from: "€10", unit: "per m²", note: "Afhankelijk van dakbedekking en mosaanslag" },
  "terras-reinigen": { from: "€5", unit: "per m²", note: "Inclusief voorbehandeling groene aanslag" },
  "oprit-reinigen": { from: "€5", unit: "per m²", note: "Klinkers, tegels of beton" },
  gevelreiniging: { from: "€8", unit: "per m²", note: "Afhankelijk van type steen en vervuiling" },
  "schutting-reinigen": { from: "€6", unit: "per strekkende meter", note: "Hout of composiet; beide zijden op aanvraag" },
};

export const priceFactors = [
  { title: "Aantal en grootte van de ramen", text: "Meer glas is meer werk. Een serre, dakkapel of erker telt mee." },
  { title: "Hoogte en bereikbaarheid", text: "Ramen op de derde verdieping of boven een aanbouw kosten iets meer tijd." },
  { title: "Frequentie", text: "Bij een vast schema (elke 4, 6 of 8 weken) betaalt u per beurt minder dan bij een eenmalige beurt." },
  { title: "Binnen of alleen buiten", text: "De binnenzijde meenemen is mogelijk tegen een gecombineerd tarief." },
  { title: "Extra's", text: "Kozijnen, zonnepanelen of dakgoten combineren scheelt in de prijs ten opzichte van losse afspraken." },
];

export const pricingFaq = [
  {
    q: "Wat kost een glazenwasser gemiddeld per keer?",
    a: "Voor de buitenzijde van een gemiddelde rijtjeswoning start het tarief in de regio Rosmalen en Den Bosch vanaf €35 per beurt. Bij een vast schema ligt de prijs per beurt lager dan bij een eenmalige afspraak.",
  },
  {
    q: "Is een abonnement goedkoper dan losse beurten?",
    a: "Ja. Bij een periodiek schema kunnen wij efficiënter plannen en dat voordeel geven wij door in de prijs per beurt. Bovendien blijft het glas schoner, waardoor iedere beurt sneller gaat.",
  },
  {
    q: "Betaal ik voorrijkosten?",
    a: "Binnen ons vaste werkgebied (Rosmalen, Den Bosch, Vught, Berlicum, Heesch, Nuland, Uden en omgeving) rekenen wij geen voorrijkosten.",
  },
  {
    q: "Hoe krijg ik een exacte prijs?",
    a: "Vul onze prijscalculator in: u kiest uw woningtype, aantal ramen en frequentie en ziet direct de prijs. Liever persoonlijk? Bel 06-83653511 of laat u terugbellen.",
  },
];
